import { FuseUtils } from '@fuse/index';
import { appsConfigs } from 'app/appsConfigs';
import { LoginConfig } from 'app/Core/Funcionalidade/Auth/login/LoginConfig';
import React from 'react';
import { Redirect } from 'react-router-dom';

let routeConfigs = [
    LoginConfig,
];

if (!document.location.pathname.includes("/pub-")) {
    routeConfigs = [
        LoginConfig,
        ...appsConfigs
    ];
}

const routes = [
    ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path: '/',
        component: () => <Redirect to="/pub-login" />
    }
];

export default routes;
